export default __webpack_public_path__ + "static/media/footer-bg.8a7017f1.png";